import React, {PropTypes} from "react";
import Banner from "../../components/common/Banner";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

class ReferralHome extends React.Component {

  constructor(props) {
    super(props);
    this.state = {department: this.props.emp.personal.employee.department};
  }

  componentDidMount() { }

  render() {

    return (
      <div>
        <Banner name="Quikr Job Referrals"/>

            <div className="container">
                  <div className="wrapper-1">
                      <div className="row clearfix">
                          <div className="col-xs-12">
                              <div className="tab-content">
                                  <ul className="nav nav-tabs tabs responsive" role="tablist">
                                      <li
                                          className={window.location.hash.split('?')[0].split('/')[3] == undefined || window.location.hash.split('?')[0].split('/')[3] == "jobReferral" ? "active" : null || window.location.hash.split('?')[0].split('/')[3] == "referral" ? "active" : null}
                                          rel="jobReferral"><a href="#/1/referral/jobReferral"  rel="jobReferral" role="tab" data-toggle="tab">Job Referrals</a>
                                      </li>

                                      <li
                                         className={window.location.hash.split('?')[0].split('/')[3] == undefined || window.location.hash.split('?')[0].split('/')[3] == "myReferral" ? "active" : null }
                                         rel="myReferral"><a href="#/1/referral/myReferral"  rel="myReferral" role="tab" data-toggle="tab">My Referrals</a>
                                      </li>

                                      {this.props.emp.hr ? <li className={window.location.hash.split('?')[0].split('/')[3] == undefined || window.location.hash.split('?')[0].split('/')[3] == "referralAdmin" ? "active" : null }
                                            rel="referralAdmin"><a href="#/1/referral/referralAdmin" rel="referralAdmin" role="tab" data-toggle="tab">Admin</a></li>: null}

                                      {this.props.emp.hr ? <li className={window.location.hash.split('?')[0].split('/')[3] == undefined || window.location.hash.split('?')[0].split('/')[3] == "referralDashboard" ? "active" : null }
                                                                                   rel="referralDashboard"><a href="#/1/referral/referralDashboard" rel="referralDashboard" role="tab" data-toggle="tab">Referral Dashboard</a></li>: null}
                                  </ul>

                                  <div className="tab-content responsive">
                                      <ReactCSSTransitionGroup transitionName="example"
                                                               transitionAppear={true} transitionAppearTimeout={500}
                                                               transitionEnter={false} transitionLeave={false}>

                                          {React.cloneElement(this.props.children, this.state )}
                                      </ReactCSSTransitionGroup>
                                  </div>


                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        </div>

    );
  }
}

ReferralHome.propTypes = {};

 export default ReferralHome;



/** WEBPACK FOOTER **
 ** ./src/components/Referral/ReferralHome.js
 **/